import {httpPost} from './base'
// tab1 订单运营数据
export const loadRechargeCard = (page, pageSize, params) => { return httpPost('voipOperate/rechargeCard/' + page + '/' + pageSize, params).then(res => res) }
export const loadRechargeCardUsed = (page, pageSize, params) => { return httpPost('voipOperate/rechargeCardUsed/' + page + '/' + pageSize, params).then(res => res) }
export const loadThreeRates = (params) => { return httpPost('voipOperate/threeRates', params).then(res => res) }
export const loadSubCourseRank = (params) => { return httpPost('voipOperate/subCourseRank', params).then(res => res) }
export const loadTimeSpread = (params) => { return httpPost('voipOperate/timeSpread', params).then(res => res) }



// WEBPACK FOOTER //
// ./src/api/voip-operate.js